module.exports = __webpack_public_path__ + "src/routes/report/2.jpg?81b7e130";


//////////////////
// WEBPACK FOOTER
// ./src/routes/report/2.jpg
// module id = 2859
// module chunks = 1